import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { Booking } from 'shared-types/booking';

import { bookingInitialState } from './constants';

const bookingSlice = createSlice({
  name: 'booking',
  initialState: bookingInitialState,
  reducers: {
    setCurrentBooking: (state, action: PayloadAction<Booking | null>) => {
      state.currentBooking = action.payload;
    },
  },
});

export const { setCurrentBooking } = bookingSlice.actions;

export default bookingSlice.reducer;
